<template>
  <v-container class="mx-16 py-1">
    <v-expansion-panels v-model="isOpen"> 
      <v-expansion-panel class="rounded-pill" >
        <v-expansion-panel-header>Filtros ({{ selectedFilters.length }})</v-expansion-panel-header>
        <v-expansion-panel-content class="overlay-panel">
          <v-list>
            <v-list-group
              v-for="(filter, index) in filters"
              :key="index"
              class="headers pb-0"
            >
              <template v-slot:activator>
                <v-icon left>{{ filter.icon }}</v-icon>
                <v-list-item-title>{{ filter.label }}</v-list-item-title>
              </template>

              <v-list-item
                class="d-inline-flex pa-1"
              >
                <!-- Tipo select -->
                <v-list-item-content 
                  v-if="filter.type === 'select'" 
                  class="pa-3 ma-0"
                  :key="index"
                >
                  <v-btn 
                    v-for="(item, index) in filter.user_values" 
                    class="rounded-pill px-2 py-0 ma-1 no-uppercase depressed" 
                    outlined
                    @click.native="updateValue(item, filter)"
                  >
                  {{ item.text }}
                  </v-btn>
                </v-list-item-content>

                <!-- Tipo date -->
                <v-list-item-content v-else-if="filter.type === 'date'" class="px-3 ma-0">
                    <app-date-picker
                      autocomplete="off"
                      :is-chip="true"
                      :label="filter.label"
                      :value="filter.value"
                      @input="updateDate(filter, $event)"
                      @remove-filter="removeFilter(filter)"
                    />
                </v-list-item-content>

                <!-- Tipo number -->
                <v-list-item-content v-else-if="filter.type === 'number'" class="px-3 ma-0">
                <v-text-field
                  class="pa-0 ma-0"
                  label="Valor..."
                  v-model="text_input"
                  type="number"
                  @change="updateValueText(filter,text_input)"
                  outlined
                />
                </v-list-item-content>
                <v-list-item-content v-else-if="filter.type === 'text'" class="px-3 pb-0 ma-0">
                  <!-- Tipo texto -->       
                  <v-text-field  
                    class="pa-0 ma-0"
                    label="Valor..."
                    v-model="text_input"
                    @change="updateValueText(filter, text_input)"
                    outlined
                  />
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-btn class="rounded-pill ma-4 reset-filters-btn depressed" @click="resetAllFilters">
              <span>Borrar Filtros &nbsp;</span>
              <AppIcon :src="require(`@/assets/delete-filters.svg`)" :size="29" />
            </v-btn>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>


<script>
import {mapGetters, mapState} from "vuex";
import {mapFields} from "vuex-map-fields";
import {vuexPrefix, vuexPrefix2} from "@/store/vuex_utils";
import AppDatePicker from "@/components/layout/AppDatePicker.vue";

export default {
  name: "AppSearchBar",
  components: {
    AppDatePicker,
  },
  data() {
    return {
      selectedFilters: [], // Filtros seleccionados
      selectedState: null, // Estado seleccionado actualmente
      menu: false,
      selectMenu: true,
      textMenu: false,
      text_input:'',
      date_text: undefined,
      isOpen: false,
    };
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    conditions:{
      type: Object,
      required: false,
    },
    pin_state: {
      type: Boolean,
      default: false,
    },
    initial_filters: {
      type: Array,
      default: () => ([]),
    },
  },  
  methods: {
    updateValue(item, filter){
      if (!this.selectedFilters.includes(filter)) {
        this.selectedFilters.push(filter);
      }
      this.$emit('updateObject', {key: filter.name ,value:item.value ,text:item.text})
      this.isOpen = false;
    },
    resetAllFilters() {
      this.selectedState = null;
      this.selectedFilters = [];
      this.$emit('resetAllFilters',{})
      this.isOpen = false;
    },
    removeFilter(param){
      this.$emit('updateObject',{key:param,value:'',text:''})
      this.isOpen = false;
    },
    updateValueText(filter,text) {
      if (!this.selectedFilters.includes(filter)) {
        this.selectedFilters.push(filter);
      }
      this.$emit('updateObject',{key:filter.name,value:text,text:text})
      this.isOpen = false;
    },
    updateDate(filter,text) {
      if (!this.selectedFilters.includes(filter)) {
        this.selectedFilters.push(filter);
      }
      this.$emit('updateObject',{key:filter.name,value:text,text:text})
      this.isOpen = false;
    },
  },
  computed: {
    // Filtros sin "state" (fix_state)
    mainFilters() {
      if (this.pin_state && this.filters['state']){
        // return filters without state
        return Object.keys(this.filters).filter(f => f !== 'state').reduce((obj, key) => {
          obj[key] = this.filters[key];
          return obj;
        }, {});
      }
      return this.filters;
    },
    ...mapGetters({ 
      is_mobile: "is_mobile",
    }),

  }
};
</script>

<style scoped>
.headers {
  border-bottom: 2px solid rgba(217, 217, 217, 1);
}

.headers:first-child {
  border-top: 2px solid rgba(217, 217, 217, 1);
}

</style>

<style>

.v-list .v-list-item--active {
  border-bottom: 2px solid rgba(217, 217, 217, 1);
}

.v-expansion-panel-content__wrap {
  padding: 0;
}

.reset-filters-btn {
  background-color: rgba(217, 217, 217, 1) !important;
  text-transform: none;
}

.overlay-panel {
  position: absolute;
  left: -10vw;
  right: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10;
  background-color: white;
}

@media (max-width: 600px) {
  .overlay-panel {
    left: -19vw;
  }
}

.no-uppercase {
  text-transform: capitalize;
}
</style>